<template>
  <FlatActionButton
    :action="handleButtonClick"
    :class="$style.dismissButton"
  >
    {{ buttonText }}
  </FlatActionButton>
</template>

<script>

import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';

export default {
  name: 'DismissButton',

  components: {
    FlatActionButton,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    handleClick: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    handleButtonClick(e) {
      this.handleClick(e, this.item);
    },
  },
};
</script>
<style scoped module>
@value (gradientDark1) from '~css/colors.css';

.dismissButton {
  background: transparent;
  border: 0;
  color: gradientDark1 !important; /* need !important to override a global with !important */
  font-weight: 700;
  margin-left: 15px;
}
</style>
